import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from '@tanstack/react-router';

import {
  selectAuthError,
  selectForgotPasswordEmailAddress,
} from '@/store/selectors/auth';
import { useAppDispatch } from '@/store';
import RecoveryVerifyEmailOtpForm from '@/components/organism/PasswordRecovery/RecoveryVerifyEmailOtpForm';
import { verifyRecoveryOtpThunk } from '@/store/thunks/auth/verifyRecoveryOtpThunk';
import { MIN_LEN } from '@/constants';

const OTP_LENGTH = 6;

export default function RecoveryVerifyEmailOtpPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const error = useSelector(selectAuthError);
  const emailAddress = useSelector(selectForgotPasswordEmailAddress);

  const handleSubmit = React.useCallback(
    async(code: string): Promise<void> => {
      if (code.trim().length !== OTP_LENGTH) return;
      if (typeof emailAddress !== 'string' || emailAddress.trim().length === MIN_LEN) return;

      try {
        await dispatch(verifyRecoveryOtpThunk({ emailAddress, code })).unwrap();
        void navigate({ to: '/reset-password/two-factor-verify' });
      } catch {
        // error handled in redux
      }
    },
    [dispatch, emailAddress, navigate]
  );

  return (
    <RecoveryVerifyEmailOtpForm
      error={error}
      onSubmit={(code) => {
        void handleSubmit(code);
      }}
    />
  );
}
